const SVGComponent = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M10 16.7853C10 14.4184 11.9188 12.4996 14.2857 12.4996C14.3046 12.4996 14.3235 12.4997 14.3424 12.5C14.7052 12.5047 14.9949 12.7944 14.9996 13.1572C14.9999 13.1761 15 13.195 15 13.2139C15 15.5808 13.0812 17.4996 10.7143 17.4996C10.4887 17.4996 10.2672 17.4822 10.051 17.4486C10.0174 17.2324 10 17.0109 10 16.7853ZM10 16.7853C10 14.4184 8.08122 12.4996 5.71429 12.4996C5.69536 12.4996 5.67647 12.4997 5.65761 12.5C5.29481 12.5047 5.00507 12.7944 5.00037 13.1572C5.00012 13.1761 5 13.195 5 13.2139C5 15.5808 6.91878 17.4996 9.28571 17.4996C9.5113 17.4996 9.73281 17.4822 9.94899 17.4486C9.98257 17.2324 10 17.0109 10 16.7853ZM10 11.6663V17.4996M11.7041 3.6546L10.5206 2.70776C10.2162 2.46428 9.78377 2.46428 9.47942 2.70776L8.29586 3.6546C8.06151 3.84209 7.74444 3.88907 7.46579 3.77761L6.26521 3.29738C6.05835 3.21463 5.83333 3.36698 5.83333 3.58977V6.66629C5.83333 8.96748 7.69881 10.833 10 10.833C12.3012 10.833 14.1667 8.96748 14.1667 6.66629V3.58977C14.1667 3.36698 13.9416 3.21463 13.7348 3.29738L12.5342 3.77761C12.2556 3.88907 11.9385 3.84209 11.7041 3.6546Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
export default SVGComponent
